/**
 * ---------------------------------------------------
 * ENVIA INDICADORES GERAIS
 * ---------------------------------------------------
 */
export const GENERAL_INDICATORS_REQUEST =
  '@indicator/GENERAL_INDICATORS_REQUEST';
export const GENERAL_INDICATORS_SUCCESS =
  '@indicator/GENERAL_INDICATORS_SUCCESS';
export const GENERAL_INDICATORS_FAILURE =
  '@indicator/GENERAL_INDICATORS_FAILURE';

/**
 * ---------------------------------------------------
 * GET COMPETENCIAS
 * ---------------------------------------------------
 */

export const GENERAL_COMPETENCES_REQUEST =
  '@indicator/GENERAL_COMPETENCES_REQUEST';
export const GENERAL_COMPETENCES_SUCCESS =
  '@indicator/GENERAL_COMPETENCES_SUCCESS';
export const GENERAL_COMPETENCES_FAILURE =
  '@indicator/GENERAL_COMPETENCES_FAILURE';
